import * as yup from "yup";
import {
  hasAreaBelowRegion,
  type AddressFormat,
  type AddressFormValues,
} from "./helpers";

export const buildAddressSchema = (
  format: AddressFormat | null,
): yup.ObjectSchema<AddressFormValues> => {
  const belowRegion = hasAreaBelowRegion(format);
  return yup.object({
    regionId: yup.string().required("Selecciona una opción"),
    areaId: yup
      .string()
      .defined()
      .test(
        "area-required",
        "Selecciona una opción",
        (value) => !belowRegion || !!value,
      ),
    city: yup
      .string()
      .defined()
      .test(
        "city-required",
        "La ciudad es requerida",
        (value) => belowRegion || !!value.trim(),
      ),
    route: yup.string().trim().required("La calle es requerida"),
    streetNumber: yup.string().trim().required("El número es requerido"),
    apartment: yup.string().trim().defined(),
  });
};
